import { RegistrationType } from 'app/features/manual-input-registration/models/registration-type';
import { RegistrationModel } from 'app/features/manual-input-registration/models/server/registration-model';
import { ProductBoxRegistration } from 'app/shared/components/product-box/models/product-box-registration';
import { LocationRegistration } from 'app/shared/features/location-selector/models/location-registration';
import { LocationRegistrationModel } from 'app/shared/features/location-selector/models/server/location-registration-model';
import { RowRegistration } from 'app/shared/features/map-row-selector/models/row-registration';

export interface Registration {
    activityNumber: number;

    batchNumber: number | undefined;

    amountResult: number | undefined;

    containerNumbers: number[];

    employeeNumber: number;

    productBoxRegistrations: ProductBoxRegistration[];

    registrationType: RegistrationType;

    registrationTimestamp: number;

    rowRegistrations: RowRegistration[];

    locationRegistrations?: LocationRegistration | undefined;
}

export const mapRegistrationToModel = ({
    activityNumber,
    amountResult,
    batchNumber,
    containerNumbers,
    employeeNumber,
    productBoxRegistrations,
    registrationTimestamp,
    registrationType,
    rowRegistrations,
    locationRegistrations,
}: Registration): RegistrationModel => {
    let locationModel: LocationRegistrationModel[];
    if (locationRegistrations)
        locationModel = [
            {
                locationNumber: locationRegistrations.locationNumber,
                locationFinished: locationRegistrations.registrationStatus === 'done',
            },
        ];
    else {
        locationModel = rowRegistrations.map((rowRegistration) => ({
            locationNumber: rowRegistration.rowNumber,
            locationFinished: rowRegistration.registrationStatus === 'done',
        }));
    }
    return {
        activityNumber,
        batchNumber,
        containerNumbers,
        employeeNumber,
        locations: locationModel,
        productBoxRegistrations,
        registrationTimestamp: new Date(registrationTimestamp),
        registrationType,
        result: amountResult,
    };
};
